import React from "react";
import { Transaction, TransactionType } from "@common/types/transaction";
import "./TransactionInstitution.scss";
import { getConnectionLabel } from "@common/helpers/financialConnection";
import { getLeadingAccountConnection } from "@common/helpers/financialAccount";
import {
    getIntegrationConnectionInstitutionName,
    isIntegrationConnection,
} from "@common/helpers/integrationConnection";
import { AccountInstitutionIcon } from "@components/institution/AccountInstitutionIcon";

interface TransactionInstitutionProps {
    transaction: Transaction;
}

export const TransactionInstitution: React.FC<TransactionInstitutionProps> = ({
    transaction,
}) => {
    if (transaction.type === TransactionType.IMPORTED) {
        return null;
    }

    const connection = getLeadingAccountConnection(
        transaction.financialAccount,
    );

    return connection ? (
        <div className="transaction-institution">
            <AccountInstitutionIcon
                account={transaction.financialAccount}
                connection={connection}
                size="sm"
            />

            <div className="transaction-institution__name">
                {isIntegrationConnection(connection)
                    ? getIntegrationConnectionInstitutionName(connection)
                    : getConnectionLabel(connection)}
            </div>
        </div>
    ) : null;
};
